export enum Routes {
    // GET_SCENARIO_PAGE = 'api/v1/get-scenario-page',
    POST_SCENARIO_PAGE = 'uia/RequestInteraction',
    POST_PROCESS_ACTION = 'uia/ProcessAction',
    WS_SOCKET = 'uia/socket',
    GET_CAPTCHA = 'captcha',
    GET_CAPTCHA_DONE = 'captcha/done',
}
